const isResponsiveXS = () => window.matchMedia("only screen and (max-width: 575.98px)").matches,
      isResponsiveSM = () => window.matchMedia("only screen and (max-width: 767.98px)").matches,
      isResponsiveMD = () => window.matchMedia("only screen and (max-width: 1050px)").matches,
      prefix         = "clf2020";

export {
    isResponsiveXS,
    isResponsiveSM,
    isResponsiveMD,
    prefix
}